import i18n from '@/i18n'
/*
 * @description: 保存通用请求定义
 * @author: Vincent
 * @since: 2020-03-31 14:35:16
 * @version: 1.0
 */
import axios from 'axios'
import { removeAuthed, removeToken } from './auth'
import appConfig from '@/config/app-config'
import router from '@/framework/router'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/framework/utils/auth'
import store from '@/framework/store'
import jsCookie from "js-cookie";
import { sortKey } from '@/framework/utils'
import JsMd5 from 'js-md5'
import JSEncrypt from 'jsencrypt';

let requestMap = new Map();
let defaultName = null;
if (appConfig.requests && appConfig.requests instanceof Array
  && appConfig.requests.length > 0) {
  defaultName = appConfig.requests[0].name;
}


// 创建加密对象实例
const encryptor = new JSEncrypt();
// 设置公钥
const pubKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiVl1MeSaS/gncsjSTJIQJHLpuXj4AVCH3NTEb2WQjkFMDwQPNpMn3Wf0FDW4LkqXu9U7Flm+prF8bGZr2GoSZzTR6fQEM2Ce7DRm0xbWDNqj2I54+WqD1Tk/NfesTgno8rw2wdMnZ6x2rkLN1Vpmi5IV+xtHevKtLAIPFpdp1fW31/J8y/qgZAmvwuAK7XghG9VfYrWamKSPO3LGJ374jQmfiaa+6DuO4RqLuCldz04sl965g2lbulyShcVZzKPYBehF52XmsEgUkSvkox3C0tjJII03IsKsaRRCGB/jknbJT51ScQCYb4xdNP65yoB3FqS5GKTPwKrWYcXiDiKCBwIDAQAB'; // 公钥字符串
encryptor.setPublicKey(pubKey);


/**
 * 获取请求实例，没有则创建
 *
 * @param {string} name   实例名称
 * @returns {Object}      axios请求实例
 */
export function getRequest(name) {
  let request;
  let requestName = defaultName;
  if (name) {
    requestName = name;
  }
  if (requestMap == undefined) {
    requestMap = new Map();
  }
  if (requestName) {
    request = requestMap.get(requestName);
    if (!request) {
      request = buildRequest(requestName);
      requestMap.set(requestName, request);
    }
  }
  return request;
}


/**
 * 创建请求
 *
 * @param {string} name   实例名称
 * @returns {Object}      axios请求实例
 */
function buildRequest(name) {
  let instance
  if (appConfig.requests && appConfig.requests instanceof Array) {
    // 找到对应的定义
    let requestConfig
    appConfig.requests.forEach(item => {
      if (item.name === name) {
        requestConfig = item
      }
    })
    if (requestConfig) {
      // 构建实例
      instance = axios.create({
        baseURL: requestConfig.baseApi, // url = base url + request url
        timeout: requestConfig.timeout, // request timeout
        md5Compare: requestConfig.md5Compare || false,
      })
      if (requestConfig.crossDomain) {
        instance.defaults.withCredentials = true
      }
      // 请求配置
      instance.interceptors.request.use(
        config => {
          let notTokenList = ["/portal/bidNotice/list", "/portal/bidNotice/bid/list", "/portal/notice/queryUnReadBulletBox", "/portal/system/org/getOrgCode", "/portal/notice/queryList"]
          if (getToken() && !notTokenList.includes(config.url)) {
            config.headers.Authorization = getToken()
          }
          if (config.url.includes('portal/supplier/login')) {
            config.headers.Authorization = ""
          }
          let str = paramsFn(config)
          // 加密内容
          const encrypted = encryptor.encrypt(str);
          config.headers['SecretToken'] = encrypted
          config.headers['customlanguage'] = store.getters.lang
          config.headers['customtimeZone'] = store.getters.timeZone
          let notAccessClientList = ['/portal/newBidSupplierSign/file/page']
          let regex = /^\/portal\/newBidSupplierSign\/\d+$/;
          // 这两个条件的url地址就传accessClientType和accessClientRandom
          if((notAccessClientList.includes(config.url) || regex.test(config.url) || window.location.pathname=="/reconciliation-statement"))  { 
            let num = Date.now()+'';
            config.headers.accessClientRandom = num;
            config.headers.accessClientType = JsMd5(num);
          }
          let result = config
          if (requestConfig.requestConfig) {
            result = requestConfig.requestConfig(config)
          }
          return result
        },
        error => {
          Promise.reject(error)
        }
      )
      // 应答处理
      instance.interceptors.response.use(
        response => {
          if (requestConfig.success) {
            return requestConfig.success(response)
          } else {
            return defaultSusccess(response)
          }
        },
        error => {
          if (requestConfig.error) {
            return requestConfig.error(error)
          } else if (error.message === 'Request failed with status code 401') {
            let msg = i18n.t('utils.request.2595929-0')
            Message({
              message: msg,
              type: 'error',
              duration: 3 * 1000
            })
            // 清空数据
            store.commit('user/CLEAR_INFO')
            store.commit('permission/CLEAR_PERMISSION')
            store.commit('tagsView/DEL_ALL_VISITED_VIEWS')
            store.commit('tagsView/DEL_ALL_CACHED_VIEWS')
            // 清空cookie
            removeAuthed()
            removeToken()
            localStorage.removeItem('userInfo')
            localStorage.removeItem('user')
            localStorage.removeItem('menus')
            localStorage.removeItem('loginSupplier')
            localStorage.removeItem('isCustomUser')
            localStorage.setItem('sessionEpoch', Date.now())
            router.push(appConfig.loginPath)
          } else {
            return defaultError(error)
          }
        }
      )
    }

  }
  return instance
}

/**
 * 默认成功应答的处理
 *
 * @param {Object} response     成功应答
 */
let flag = true;
function defaultSusccess(response) {
  const res = response.data
  // console.log('res========',res);
  const { headers, config } = response
  // 解决漏洞
  if (config.md5Compare) {
    if (JsMd5(JSON.stringify(res)) !== headers['response-sign']) {
      return Promise.reject({ code: 401, reason: '数据验签失败' })
    }
  }
  if (res) {
    if (res.code == 200) {
      return res;
    } else if (res.error_code === '100') {
      return res;
    // } else if (res.error_code === '401') {
    } else if (((res.error_code === '401') || (res.error_code === '403') || (res.code == '403') || (res.code == '401') && flag)) {
      // 401代表未登录或登录超时，跳转到登录页面
      if (router.currentRoute.path !== appConfig.loginPath) {
        // 如果不是登录页面，则退出登录跳转到登录页面，给出一个停留的确认框体验更好
        let msg = i18n.t('utils.request.2595929-1')
        if (res.reason) {
          msg = res.reason
        }
        if(flag) {
          Message({
            message: msg,
            type: "error"
          });
        }
        flag = false;
        removeAuthed()
        localStorage.removeItem("user");
        localStorage.setItem("sessionEpoch", Date.now());
        jsCookie.remove("Admin-Token");
        localStorage.removeItem("supplierCode")
        localStorage.removeItem("supplierId")
        router.push({ path: '/index' });
        // MessageBox({
        //   title: '提示',
        //   message: msg,
        //   type: 'error',
        //   showClose: false,
        //   callback: function (action, instance) {
        //     localStorage.removeItem("user");
        //     jsCookie.remove("Admin-Token");
        //     localStorage.removeItem("supplierCode")
        //     localStorage.removeItem("supplierId")
        //     router.push({ path: '/index' });
        //     window.navigation.reload();
        //   }
        // })
        return Promise.reject(res)
      }
    } else if (res.error_code === '400') {
      let message = ''
      if (res && res.response_detail) {
        message = res.response_detail
      } else if (res && res.response_body) {
        message = res.response_body.message
      }
      Message({
        message: message,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(error)
    } else if (res.code == 500) {
      return res;
    } else{
      return response;
    }
  }
  // return Promise.reject(res)
  return defaultError(res)
}

// 需要测试：
// 1.网络失败时
// 2.请求返回的失败时
// 3.登录时返回401
// 4.登录后再请求时返回401

/**
 * 默认的错误处理
 *
 * @param {Object} error        错误信息对象
 */
function defaultError(error) {
  let message = i18n.t('utils.request.2595929-2')
  if (error && error.response_detail) {
    message = error.response_detail
  } else if (error && error.message) {
    message = error.message
  }
  Message({
    message: message,
    type: 'error',
    duration: 3 * 1000
  })
  return Promise.reject(error)
}

export function mapToFormDataString(data) {
  let ret = ''
  for (let it in data) {
    if (data[it] || data[it] === 0) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
  }
  if (ret.length > 0) {
    ret = ret.substr(0, ret.length - 1)
  }
  return ret
}

export default getRequest("common");


function parameterSplicing(params) {
  let key = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
  return key
}

function paramsFn(config) {
  let nowUrl = config.url[0] !== '/' ? '/' + config.url : config.url
  let params = ''
  let str = ''
  if (config.method === 'get') {
    if (config.params) {
      params = parameterSplicing(config.params)
      str = nowUrl + '?' + params
    } else if (config.data) {
      params = parameterSplicing(config.data)
      str = nowUrl + '?' + params
    } else {
      str = nowUrl
    }
  } else {
    if (config.fileParams) {
      let { fileParams } = config
      if (fileParams.file) {
        delete fileParams.file
      }
      if (fileParams.files) {
        delete fileParams.files
      }
      if (fileParams.multipartFile) {
        delete fileParams.multipartFile
      }
      if (JSON.stringify(fileParams) === '{}') {
        str = nowUrl
      } else {
        let sortData = sortKey(fileParams)
        str = nowUrl + JSON.stringify(sortData).replace(/[""]/g, '')
      }
    } else if (config.params) {
      str = nowUrl + JSON.stringify(config.params)
    } else if (config.data) {
      if (JSON.stringify(config.data) === '{}') {
        str = nowUrl + '{}'
      } else {
        str = nowUrl + JSON.stringify(config.data)
      }
    } else {
      str = nowUrl
    }
  }
  // console.log(str, '-str')
  return JsMd5(str)
}
